export const WITH_LAYOUT = 'WITH_LAYOUT';
export const GET_LOGIN = 'GET_LOGIN';
export const GET_SYSTEMS = 'GET_SYSTEMS';
export const MINI_SIDEBAR = 'MINI_SIDEBAR';